<template>
  <section class="image-text-group content-block" :class="brandClasses">
    <div class="container">
      <div class="row">
        <div class="image-text-group__container col-lg-8 offset-lg-2">
          <image-text-item
            v-if="isFirstItemFilled"
            :variant-two-images="isTwoImagesVariant"
            :image="fields.firstItemImage"
            :description="fields.firstItemDescription"
          />
          <image-text-item
            v-if="isSecondItemFilled"
            :variant-two-images="isTwoImagesVariant"
            :image="fields.secondItemImage"
            :description="fields.secondItemDescription"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ImageTextItem from './ImageTextItem/ImageTextItem.vue';
import { useJssStore } from '../../stores/jssStore';
import type { ImageTextGroupProps } from './types';

const props = withDefaults(defineProps<ImageTextGroupProps>(), {
  fields: () => ({}),
});

const jssStore = useJssStore();

const brandClasses = computed(() => [
  jssStore.brandName === 'ChefBrewer' && 'bottom-green-border top-green-border',
]);
const isFirstItemFilled = computed(() => !!props.fields.firstItemImage?.value?.src);
const isSecondItemFilled = computed(() => !!props.fields.secondItemImage?.value?.src);
const isTwoImagesVariant = computed(() => isFirstItemFilled.value && isSecondItemFilled.value);
</script>

<style lang="scss">
@import './scss/ImageTextGroup.scss';
</style>
